import { useInstance } from 'react-ioc';
import { AppSettings } from 'models/app-settings';

export function useSettings(): AppSettings {
    return useInstance(AppSettings);
}